var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeSquaresLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2157.32,
    height: 298.985,
    viewBox: "0 0 2157.32 298.985",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 224.239h1617.994V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 298.985)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 185.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 185.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178 185.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 120.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 55.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 120.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178 120.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51 55.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178 55.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.627-5.373-12-12-12h-27c-6.627 0-12 5.373-12 12v27c0 6.627 5.373 12 12 12h27c6.627 0 12-5.373 12-12z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.972 130.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-32.453 15.129-55.145 40.017-55.145 25.132 0 39.529 23.913 39.529 55.876 0 29.769-13.908 55.146-39.529 55.146C14.641 55.877 0 31.964 0 0m118.83 1.952c0-54.169-32.452-86.621-80.766-86.621-48.556 0-77.348 36.844-77.348 83.937 0 49.289 31.721 86.133 80.033 86.133 50.509 0 78.081-37.821 78.081-83.449"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.293 190.078)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-5.857 2.685-14.396 4.88-24.4 4.88-19.522 0-26.354-10.004-26.354-23.18v-4.148h72.469v-119.318h-37.088v91.99H-50.51v-91.99h-37.088v91.99h-38.796v-91.99h-37.089v91.99h-15.86v27.328h15.86v1.952c0 14.152 4.392 28.549 15.372 38.553 7.809 7.564 19.521 12.688 35.624 12.688 8.297 0 16.105-2.196 20.741-3.904L-100.042 0c-2.684 1.464-6.588 2.44-10.493 2.44-4.88 0-8.296-1.708-10.979-4.148-3.904-3.903-5.124-10.98-5.124-17.324v-3.416h39.04v4.88c0 33.184 25.377 51.729 62.221 51.729 11.713 0 25.377-2.44 33.184-6.345z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(690.32 51.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-6.588-3.172-19.033-5.612-33.186-5.612-38.552 0-63.197 23.669-63.197 61.001 0 34.892 23.914 63.441 68.322 63.441 9.76 0 20.497-1.708 28.305-4.637l-5.857-27.572c-4.391 1.952-10.981 3.66-20.741 3.66-19.519 0-32.207-13.908-31.964-33.428 0-21.716 14.64-33.428 32.697-33.428 8.785 0 15.617 1.464 21.228 3.903z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.356 121.513)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 9.028-3.904 24.156-20.984 24.156C-36.6 24.156-42.943 9.76-43.92 0zm-43.676-25.377c.975-15.372 16.348-22.691 33.672-22.691 12.688 0 22.936 1.708 32.942 5.124l4.878-25.133C15.617-73.201.732-75.642-15.371-75.642c-40.506 0-63.686 23.425-63.686 60.757 0 30.257 18.789 63.686 60.27 63.686 38.551 0 53.191-30.013 53.191-59.537 0-6.344-.732-11.956-1.218-14.641z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(836.227 74.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c9.516-6.1 23.18-10.736 37.82-10.736 21.717 0 34.405 11.468 34.405 28.06 0 15.128-8.786 24.156-30.989 32.452-26.84 9.761-43.433 23.913-43.433 46.849 0 25.621 21.228 44.653 53.193 44.653 16.592 0 29.037-3.904 36.113-8.052l-5.857-17.325c-5.123 3.172-16.104 7.809-30.988 7.809-22.448 0-30.989-13.42-30.989-24.645 0-15.372 10.004-22.936 32.698-31.72 27.816-10.737 41.724-24.157 41.724-48.313 0-25.376-18.545-47.58-57.342-47.58-15.859 0-33.183 4.88-41.968 10.735z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040.453 118.585)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 2.929-.244 6.101-.977 8.784-3.416 13.177-14.64 24.401-30.744 24.401-22.205 0-35.625-18.789-35.625-45.141 0-23.668 11.225-43.92 34.893-43.92 13.908 0 25.865 8.54 30.744 23.18C-.732-29.523 0-25.376 0-22.204zm0-52.216h-.488c-6.588-11.469-19.52-20.74-38.553-20.74-27.572 0-50.02 23.668-50.02 59.536 0 44.409 28.547 63.686 53.436 63.686 18.301 0 30.5-9.029 36.357-20.253h.489l.73 17.812h20.254c-.488-9.76-.976-20.252-.976-32.452v-133.957H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196.123 80.764)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-12.444.244-23.18.975-32.452h-19.032l-1.22 19.276h-.489c-5.367-9.516-18.054-21.96-39.039-21.96-18.545 0-40.75 10.491-40.75 51.729v69.053h21.473v-65.15c0-22.448 7.076-37.82 26.353-37.82 14.395 0 24.401 10.005 28.303 19.764 1.221 2.928 1.953 6.832 1.953 10.981v72.225H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1293.965 108.58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-23.424.488-50.02-3.66-50.02-26.596 0-14.152 9.272-20.497 20.008-20.497 15.616 0 25.619 9.761 29.035 19.765.733 2.44.977 4.88.977 6.832zm20.74-31.964c0-10.248.489-20.253 1.709-28.305H3.172L1.465-45.385H.732c-6.587-9.271-19.275-17.567-36.113-17.567-23.912 0-36.111 16.836-36.111 33.916 0 28.549 25.375 44.165 71.004 43.921v2.439c0 9.517-2.684 27.329-26.84 27.085-11.225 0-22.692-3.173-30.988-8.784l-4.881 14.396c9.761 6.1 24.156 10.249 39.041 10.249 36.113 0 44.896-24.645 44.896-48.07z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1349.352 129.565)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 13.908-.244 25.864-.977 36.845h18.788l.976-23.425h.733c5.367 15.86 18.544 25.865 32.941 25.865 2.195 0 3.902-.244 5.855-.488V18.544c-2.197.488-4.392.488-7.32.488-15.129 0-25.865-11.223-28.793-27.328-.488-2.928-.732-6.588-.732-10.004v-62.953H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1501.61 118.829)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.242 13.421-5.613 34.648-29.77 34.648-21.96 0-31.232-19.763-32.939-34.648zm-62.953-15.372c.488-29.036 18.787-40.992 40.504-40.992 15.373 0 24.888 2.683 32.697 6.099l3.902-15.372C6.588-69.053-6.59-73.2-25.377-73.2c-36.357 0-58.072 24.156-58.072 59.78 0 35.625 20.984 63.441 55.388 63.441 38.795 0 48.801-33.672 48.801-55.389 0-4.392-.244-7.564-.732-10.004z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1546.014 70.028)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c6.588-3.903 17.813-8.296 28.549-8.296C43.92-8.296 51.24-.731 51.24 9.272c0 10.249-6.099 15.617-21.717 21.473C8.053 38.553-1.951 50.021-1.951 64.174c0 19.032 15.615 34.648 40.748 34.648 11.955 0 22.447-3.173 28.791-7.32l-5.123-15.616c-4.637 2.927-13.176 7.076-24.156 7.076-12.688 0-19.52-7.32-19.52-16.105 0-9.759 6.832-14.152 22.203-20.252 20.252-7.564 30.988-17.812 30.988-35.38 0-20.985-16.347-35.624-43.919-35.624-12.932 0-24.889 3.416-33.186 8.295z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSquaresLogo);
export default __webpack_public_path__ + "static/media/OfficeSquaresLogo.52116691f4ec67fefdf5239b7d9fb42d.svg";
export { ForwardRef as ReactComponent };